import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

export interface MetricCardFilterOption {
  label: string;
  value: string;
}

@Component({
  selector: 'lib-metric-card',
  imports: [MatMenuModule],
  templateUrl: './metric-card.html',
  styleUrl: './metric-card.css',
  providers: [CurrencyPipe],
})
export class MetricCard {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) value!: string | number;
  @Input() format: 'currency' | 'number' = 'number';
  @Input() currencyCode: string | undefined;

  // Optional
  @Input() showFilter = false;
  @Input() filterLabel = 'Today';
  @Input() filterOptions: MetricCardFilterOption[] = [];
  @Input() selectedFilter: MetricCardFilterOption | null = null;
  @Output() filterChange = new EventEmitter<MetricCardFilterOption>();

  private currencyPipe = inject(CurrencyPipe);

  onFilterSelect(option: MetricCardFilterOption): void {
    this.filterChange.emit(option);
  }

  get display(): string {
    if (this.value === null || this.value === undefined) return '—';
    if (this.format === 'currency') {
      try {
        // return new Intl.NumberFormat(undefined, {
        //   style: 'currency',
        //   currency: this.currencyCode || '₦',
        //   maximumFractionDigits: 0,
        // }).format(Number(this.value));
        return this.currencyPipe.transform(
          this.value,
          this.currencyCode || 'NGN',
          '₦',
          '1.2-2'
        )!;
      } catch {
        return new Intl.NumberFormat().format(Number(this.value));
      }
    }
    return new Intl.NumberFormat().format(Number(this.value));
  }
}
